import Head from "next/head";

function SEO({
  seoOGMeta,
  pageData,
  lastPath = true,
  swifTags = [],
  pathPrefix = "",
  docs = false,
  noindex = false,
  rssMeta,
  canonical = true,
}) {
  const defaultSEOImage =
    "https://images.contentstack.io/v3/assets/bltebc53cfaf0dd6403/bltc850aba073bc0529/663194f3714a1b9480b74c35/Opengraph_B.png";

  let pagePath = pageData.url || pageData.page_url?.url;

  if (pagePath?.indexOf("/") > -1 && lastPath) {
    const pagePathArr = pagePath?.split("/");
    for (let p of pagePathArr) {
      pagePath = p ? p : pagePath;
    }
  }
  let base =
    process.env.NEXT_PUBLIC_SITE_URL || "https://www.contentstack.com/academy";

  // If pagePath has queryParam passed then, pagePath as it is received in props else add trailing slash
  pagePath = pagePath?.includes("?") ? pagePath : pagePath && pagePath;

  let ogMeta = {
    title: `${seoOGMeta?.title || pageData?.title} | Contentstack Academy`,
    description: (
      seoOGMeta?.description ||
      pageData.description ||
      pageData.title
    )?.replace(/<[^>]*>/g, ""),
    image: seoOGMeta?.image?.url || defaultSEOImage,
    robots: seoOGMeta?.robots || "",
    canonical: canonical
      ? seoOGMeta?.canonical_url ||
        (pagePath ? `${base}${pathPrefix}/${pagePath}` : base)
      : null,
  };

  let swiftype = [
    {
      class: "swiftype",
      name: "tags",
      content: "academy",
      "data-type": "string",
    },
  ];

  if (swifTags.length) {
    swiftype = swiftype.concat(swifTags);
  }

  const removeTrailingSlash = (url) => {
    const index = url.length - 1;
    let newUrl;
    if (url.charAt(index) === "/") {
      newUrl = url.slice(0, -1);
    } else {
      newUrl = url;
    }
    return newUrl;
  };

  return (
    <Head>
      <title>{ogMeta.title}</title>
      <meta
        name="title"
        content={ogMeta.title}
      />
      <meta
        name="description"
        content={ogMeta.description}
      />
      <meta
        property="og:title"
        content={ogMeta.title}
      />
      <meta
        name="og:description"
        content={ogMeta.description}
      />
      <meta
        property="og:image"
        content={ogMeta.image}
      />
      <meta
        property="og:url"
        content={pagePath ? `${base}${pathPrefix}/${pagePath}` : base}
      />
      <meta
        name="twitter:card"
        content="summary_large_image"
      />
      <meta
        property="twitter:title"
        content={ogMeta.title}
      />
      <meta
        name="twitter:description"
        content={ogMeta.description}
      />
      <meta
        property="twitter:image"
        content={ogMeta.image}
      />
      <meta
        property="twitter:url"
        content={pagePath ? `${base}${pathPrefix}/${pagePath}` : base}
      />
      {ogMeta.robots ? (
        <meta
          name="robots"
          content={ogMeta.robots}
        />
      ) : (
        ""
      )}
      {noindex && (
        <meta
          name="robots"
          content="noindex,nofollow"
        />
      )}
      <link
        rel="icon"
        href="https://images.contentstack.io/v3/assets/bltebc53cfaf0dd6403/blt42aa09efbf286c12/665d4619d52e44a8b2ac61dc/academy-favicon.ico"
        type="image/x-icon"
      />
      {canonical && (
        <link
          rel="canonical"
          href={removeTrailingSlash(
            ogMeta.canonical.replace("/docs//", "/docs/")
          )}
        />
      )}
      <meta
        className="swiftype"
        name="domain-identifier"
        data-type="integer"
        content="1"
      />
      {swiftype.map((el, i) => {
        return (
          <meta
            className={el.class}
            name={el.name}
            data-type={el["data-type"]}
            content={el.content}
            key={i}
          />
        );
      })}
      {rssMeta && (
        <link
          rel="alternate"
          href={rssMeta}
          type="application/rss+xml"
          title="Contentstack Changelog RSS Feed"
        ></link>
      )}
    </Head>
  );
}
export default SEO;
